import styles from "./NavigationProgress.module.css";

export function NavigationProgress() {
  return <div className={styles.progress} aria-hidden="true" />;
}
